<template>
  <organism-customer-permission
    v-model="permissionList"
    :origin-permission-list="originPermissionList"
    :update-permission-func="sendRequestToUpdateCustomerPermission"
  ></organism-customer-permission>
</template>

<script>
import {
  getCustomerPermission,
  updateCustomerPermission,
} from "@/api/api-module-iam"

import OrganismCustomerPermission from "@/components/organisms/globalSetting/OrganismCustomerPermission.vue"
import mixins from "@/mixins"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
export default {
  name: "CustomerPermission",

  components: {
    OrganismCustomerPermission,
  },

  mixins: [mixins, mixinsObjectHelper],

  data() {
    return {
      originPermissionList: [],
      permissionList: [
        {
          module: "wpm",
          page: "Ticket Management",
          icon: "TagIcon",
          permissions: [
            {
              id: "wpmTicketTrackingAccess",
              title: "Access Page",
              enable: false,
            },
          ],
        },
        {
          module: "wpm",
          page: "Site Access",
          icon: "MaximizeIcon",
          permissions: [
            {
              id: "wpmQrAccessAccess",
              title: "Access Page",
              enable: false,
            },
          ],
        },
        // {
        //   module: "wpm",
        //   page: "Smart Hand",
        //   icon: "ThumbsUpIcon",
        //   permissions: [
        //     {
        //       id: "wpmSmartHandManagementAccess",
        //       title: "Access Page",
        //       enable: false,
        //     },
        //   ],
        // },
        // {
        //   module: "wpm",
        //   page: "Cross Connect",
        //   icon: "LinkIcon",
        //   permissions: [
        //     {
        //       id: "wpmCrossConnectAccess",
        //       title: "Access Page",
        //       enable: false,
        //     },
        //   ],
        // },
        // {
        //   module: "wpm",
        //   page: "Parcel Tracking",
        //   icon: "TruckIcon",
        //   permissions: [
        //     {
        //       id: "wpmParcelTrackingAccess",
        //       title: "Access Page",
        //       enable: false,
        //     },
        //   ],
        // },
      ],
    }
  },

  async mounted() {
    await this.getCustomerPermissionDataFromApi()
  },

  methods: {
    async getCustomerPermissionDataFromApi() {
      this.showLoading(true)
      await getCustomerPermission()
        .then(async (response) => {
          await this.mapCustomerPermission(response?.data)
        })
        .finally(() => this.showLoading(false))
    },

    async sendRequestToUpdateCustomerPermission() {
      this.showLoading(true)
      const updatedPermissionData = this.decoratePermissionData()
      await updateCustomerPermission(updatedPermissionData)
        .then(async (response) => {
          if (response) {
            this.toastSuccess("Update Successfully")
            await this.getCustomerPermissionDataFromApi()
          } else {
            this.toastError("Update Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    mapCustomerPermission(permissions) {
      this.permissionList.forEach((page) =>
        page.permissions.forEach((permission) => {
          const keys = Object.keys(permissions)
          keys.forEach((key) => {
            if (permission.id === key) {
              permission.enable = permissions[key]
            }
          })
        })
      )
      this.originPermissionList = this.deepCopyArray(this.permissionList)
    },

    decoratePermissionData() {
      let customerPermission = this.permissionList.map((page) => {
        return page.permissions.map((permission) => {
          let permissionObj = {}
          let permissionKey = ""
          const keys = Object.keys(permission)
          keys.forEach((key) => {
            if (key === "id") {
              permissionKey = permission[key]
            }
            if (key === "enable") {
              permissionObj[`${permissionKey}`] = permission[key]
            }
          })
          return permissionObj
        })
      })
      customerPermission = customerPermission.flatMap((item) => item)
      customerPermission = Object.assign({}, ...customerPermission)
      customerPermission.wpmAccess = true
      return customerPermission
    },
  },
}
</script>

<style lang="scss" scoped></style>
